import React from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../utils/globalContext";

export default ({ link = "", text, comingSoon, className = "" }) => {
  const { Trans } = useGlobalContext();
  if (comingSoon) {
    return (
      <>
        {text} <span className="comingSoon">(Coming Soon)</span>
      </>
    );
  } else if (link.match(/^[/](?![/])/)) {
    return (
      <Link to={link} className={className}>
        <Trans>{text}</Trans>
      </Link>
    );
  } else {
    return (
      <a href={link} className={className}>
        {text}
      </a>
    );
  }
};
